
import { defineComponent, computed } from "vue";
import { TokenMeta, FirestoreDocument} from "@/types/types";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    name: String,
    asset_contract_address: String,
    token_id: String
  },
  setup(props) {
    const store = useStore();
    const has_image = computed(() => {
      return !!store.getters.token(props.token_id);
    })
    const asset_str = computed(() => {
      const token = store.getters.token(props.token_id);
      if (token) {
        return token.image_thumbnail_url;
      }
      const demo_token: FirestoreDocument<TokenMeta> = store.getters.demo_token_meta(
        props.asset_contract_address,
        props.token_id
      );
      if (demo_token) {
        return `${demo_token.entity.name} - ${demo_token.entity.tag}`;
      }
      return "No token";
    });
    return { asset_str, has_image};
  }
});
